import CryptoJS from "crypto-js";
const SECRET_KEY = "@Pass$uPorTCos02";

export const StorageBox = {
  setToken: (token: string) => {
    const encryptedData = CryptoJS.AES.encrypt(token, SECRET_KEY).toString();
    localStorage.setItem("@Token_", encryptedData);
  },
  getToken: () => {
    const encryptedData = localStorage.getItem("@Token_");
    if (encryptedData !== null) {
      const decryptedData = CryptoJS.AES.decrypt(
        encryptedData,
        SECRET_KEY
      ).toString(CryptoJS.enc.Utf8);
      return decryptedData;
    }
    return null;
  },
  setRefreshToken: (refreshToken: string) => {
    const encryptedData = CryptoJS.AES.encrypt(
      refreshToken,
      SECRET_KEY
    ).toString();
    localStorage.setItem("@REFRESH_TOKEN_", encryptedData);
  },
  getRefreshToken: () => {
    const encryptedData = localStorage.getItem("@REFRESH_TOKEN_");
    if (encryptedData !== null) {
      const decryptedData = CryptoJS.AES.decrypt(
        encryptedData,
        SECRET_KEY
      ).toString(CryptoJS.enc.Utf8);
      return decryptedData;
    }
    return null;
  },
  setUser: (data: any) => {
    const encryptedData = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      SECRET_KEY
    ).toString();
    localStorage.setItem("@User_", encryptedData);
  },
  getUser: () => {
    const encryptedData = localStorage.getItem("@User_");
    if (encryptedData !== null) {
      const decryptedData = JSON.parse(
        CryptoJS.AES.decrypt(encryptedData, SECRET_KEY).toString(
          CryptoJS.enc.Utf8
        )
      );
      return decryptedData;
    } else {
      return null;
    }
  },
  clearStorage: () => {
    localStorage.clear();
  },
};
